import { cn } from "@repo/ui/lib/utils";
import { Card } from "@repo/ui/ui/card";
import type { ReactNode } from "react";

import { MoraGrid } from "~/components/mora-grid";

interface InvitationShellLayoutProps {
  /** Invite flow content rendered inside the centered card. */
  children: ReactNode;
  /** Optional class overrides for the shell card. */
  cardClassName?: string;
}

/**
 * Shared visual shell for invitation-centric flows.
 *
 * Matches onboarding chrome (Mora grid background + centered wide card)
 * without owning any route-specific navigation behavior.
 */
export const InvitationShellLayout = ({
  children,
  cardClassName,
}: InvitationShellLayoutProps) => {
  return (
    <div className="flex shrink grow flex-col">
      <div className="relative flex min-h-0 min-w-0 shrink grow items-stretch justify-center overflow-y-auto p-4 md:items-center md:overflow-hidden">
        <MoraGrid className="pointer-events-none absolute inset-0 size-full text-foreground/60" />
        <Card
          className={cn(
            "relative flex w-full min-w-0 max-w-full flex-col overflow-visible py-0 md:max-w-5xl md:overflow-hidden",
            cardClassName,
          )}
        >
          {children}
        </Card>
      </div>
    </div>
  );
};
